import React from 'react'
import Layout from '../../components/layout/layout'
import Header from '../../components/header/header'
import Nav from '../../components/nav/nav'
import Footer from '../../components/footer/footer'
import styles from './statement.module.css'

export default () => (
  <Layout>
    <Header />
    <Nav />
    <main style={{ display: 'flex', justifyContent: 'center' }}>
      <div className={styles.statement}>
        <p>
        I am an interdisciplinary, project-based artist who creates work through a process rooted in research, memory, and experimentation. The essence of my work connects personal experiences with socio-political and environmental issues; I depict the challenges we face as human beings and express my concern regarding how natural ecosystems react to societal behavior. In recent years, I have focused my work on the climate crisis affecting coral reefs, glaciers, and biodiversity.
        </p>
        <p>
        I give form to these concepts through ceramics, mixed-media installations, and painting. My process is partly spontaneous, drawing upon both current events and the imagery my subconscious has accumulated throughout my life.
        </p>
        <p>
        My works are inspired by the idea that everything is interconnected: our state of mind, the gravity and urgency of the environmental crisis, and its complex, omnipresent manifestations.
        </p>
        <p>
        Living in different parts of the world has shaped the unique evolution of my work; the situations, places, and ties to diverse cultures I have encountered have driven me to take on new challenges. I have come to realize that these experiences allow me to discover and explore a new universe of ideas, experimenting with a variety of media that spark my interest.
        </p>
      </div>
    </main>
    <Footer />
  </Layout>
)
